import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18b09ba9")

_pushScopeId("data-v-18b09ba9")
const _hoisted_1 = {
  key: 0,
  class: "rounded-lg p-4 flex items-center gap-3 fixed top-0 right-0 mt-5 mr-5 font-montserrat z-60",
  style: {"background-color":"#00875A"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "text-white text-12px" }, "Terdapat pembaharuan fitur", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "notification" }, {
    default: _withId(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/refresh-white.svg`),
              alt: "refresh",
              class: "w-5 max-w-none"
            }, null, 8, ["src"]),
            _hoisted_2
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})